import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { useToggle } from "@/shared/base/hooks/useToggle";
import { Box, Divider, Link, Stack, Typography, useTheme } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

interface Props {
  modalProps: ReturnType<typeof useToggle>;
  onClose?: () => void;
  errorMessage: string;
}

export function LoginErrorModal({ modalProps, onClose, errorMessage }: Props) {
  const theme = useTheme();

  return (
    <ActionModal
      isOpen={modalProps.open}
      onClose={onClose}
      renderHeader={() => {
        return (
          <Stack
            py={2}
            px={3}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
            height={"64px"}
          >
            {/* <WarningAmberRoundedIcon fontSize="large" color={"warning"} />

            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={600}
              marginTop={"0px !important"}
            >
              Attention!
            </Typography> */}
          </Stack>
        );
      }}
      renderBody={() => {
        return (
          <Box>
            <Divider />
            <Box p={3}>
              <Typography variant="body1" color="text.secondary">
                {errorMessage}
              </Typography>
            </Box>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"flex-end"}
            spacing={2}
          >
            <Box width={"120px"}>
              <ModalActionButton variant="primary" onClick={onClose}>
                Close
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
